import React from "react";
const VARIANTS = {
  /** In the flow, next to a title. */
  chip: "rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-semibold text-primary",
  /** A notification dot over the top-right corner of a `relative` parent; the parent's
   * accessible name must carry the count. */
  badge:
    "pointer-events-none absolute -right-1.5 -top-2 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1.5 text-[11px] font-semibold leading-none text-primary-foreground ring-2 ring-background",
};

/** A small rounded count; renders nothing for zero or unknown. */
const CountChip: React.FC<{
  count: number | undefined;
  variant?: keyof typeof VARIANTS;
}> = ({ count, variant = "chip" }) =>
  count ? (
    <span aria-hidden={variant === "badge" || undefined} className={VARIANTS[variant]}>
      {count}
    </span>
  ) : null;

export default CountChip;
